module.exports = __webpack_public_path__ + "static/media/qa.d17f4d73.svg";